import { BroadcastChannel as BroadcastChannelPolyfill } from 'broadcast-channel';
var WSC = /*#__PURE__*/function (WSC) {
  WSC["EC"] = "EcommerceWebSocketChannel";
  WSC["EN"] = "EnterpriseWebSocketChannel";
  return WSC;
}(WSC || {});
export const isBroadcastChannelSupported = ('BroadcastChannel' in globalThis);
export const BC_ECOMMERCE = isBroadcastChannelSupported ? new BroadcastChannel(WSC.EC) : new BroadcastChannelPolyfill(WSC.EC);
export const BC_ENTERPRISE = isBroadcastChannelSupported ? new BroadcastChannel(WSC.EN) : new BroadcastChannelPolyfill(WSC.EN);